module.exports = __webpack_public_path__ + "5657f2cf9414de07eb85cac236c279ac.png";